
























import { deleteExpenses, Expense, getExpenses } from "@/api/cost/expenses-api";
import ProjectAccountingTabs from "@/components/ProjectAccountingTabs.vue";
import { sumBy } from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    ProjectAccountingTabs
  }
})
export default class ExpenseListPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  expenses: Expense[] = [];

  fields = [
    { key: "estimate", label: "見積書ID" },
    { key: "title", label: "件名" },
    { key: "vendor", label: "発注先" },
    { key: "total", label: "合計金額" },
    { key: "actions", label: "" }
  ];

  get items() {
    return this.expenses.map(expense => ({
      vendor: expense.vendorName,
      id: expense.id,
      title: expense.title,
      estimate: expense.estimateId,
      total: sumBy(expense.items, item => Number(item.total))
    }));
  }

  @Watch("projectId", { immediate: true })
  onProjectIdChanged(projectId: string) {
    this.initExpenses(projectId);
  }

  async initExpenses(projectId: string) {
    this.expenses = await getExpenses(projectId);
  }

  async destroy(id: string) {
    if (!confirm("本当にこの項目を削除してもよろしいですか？")) return;
    await deleteExpenses(id);
    this.initExpenses(this.projectId);
  }
}
